import React from 'react'
import './button.css'

export default ({ children, url }) => (
  <a href={url} className="button box box--rebecca link link--rebecca">{children}</a>
)

